import { render, staticRenderFns } from "./UpdateMemberModal.vue?vue&type=template&id=a8c1c67c"
import script from "./UpdateMemberModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateMemberModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports